import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

const COMPONENT = `${API_URL}menu-analytics/component`
const PREVIEW_COMPONENT = `${API_URL}menu-analytics/preview`
const INSTALL_DASHBOARD = `${API_URL}menu-analytics/component/dashboard`

interface IComponentPost {
  sectionId: string
  name: string
  dataType: string
  chartType: string
  timeFrame: string
  customCompany: null|string
  formattedResult: string
  startDate: string | Date
  endDate: string | Date
  dataCore: any
  token: string
  totalData?: number
  isRealTime?: boolean
  outputType?: string
}
interface IInstallComponentToDashboard {
  inDashboard: boolean
  dashboardUserAccess: string[]
  token: string
  componentId: string
}

interface IComponentUpdate extends IComponentPost {
  componentId: string
  position: number
}
export const inserComponent = async ({
  sectionId,
  formattedResult,
  name,
  dataType,
  chartType,
  timeFrame,
  startDate,
  endDate,
  dataCore,
  token,
  totalData,
  isRealTime,
  customCompany ,
  outputType
}: IComponentPost) => {
  return axios.post(
    COMPONENT,
    {
      sectionId,
      name,
      dataType,
      chartType,
      timeFrame,
      customCompany,
      startDate,
      formattedResult,
      endDate,
      dataCore,
      totalData,
      isRealTime,
      outputType
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const updateComponent = async ({
  sectionId,
  name,
  dataType,
  chartType,
  timeFrame,
  formattedResult,
  startDate,
  endDate,
  dataCore,
  token,
  componentId,
  customCompany,
  position,
  isRealTime,
  totalData,
  outputType
}: IComponentUpdate) => {
  return axios.put(
    COMPONENT,
    {
      componentId,
      sectionId,
      name,
      dataType,
      chartType,
      timeFrame,
      startDate,
      formattedResult,
      customCompany,
      endDate,
      dataCore,
      token,
      position,
      totalData,
      isRealTime,
      outputType
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const deleteComponent = async (id: string, token: string) => {
  return axios.delete(COMPONENT + '/' + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const previewComponent = async ({
  sectionId,
  name,
  dataType,
  chartType,
  timeFrame,
  startDate,
  endDate,
  dataCore,
  formattedResult,
  customCompany,
  token,
  totalData,
  isRealTime,
  outputType = 'DATE' // Default to 'DATE' if not set
}: IComponentPost) => {
  return axios.post(
    PREVIEW_COMPONENT,
    {
      sectionId,
      name,
      dataType,
      chartType,
      timeFrame,
      startDate,
      endDate,
      formattedResult,
      dataCore,
      customCompany,
      totalData,
      isRealTime,
      outputType
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}
export const installDashboard = async ({
  inDashboard,
  dashboardUserAccess,
  token,
  componentId
}: IInstallComponentToDashboard) => {
  return axios.put(
    INSTALL_DASHBOARD+"?componentId="+componentId,
    {
      inDashboard,
      dashboardUserAccess,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}
